export default __webpack_public_path__ + "static/media/LemonLogo.882636f6.png";